export const getOtp = () => ({
    title: `Введите код из SMS`,
    subtitle: `код отправлен на Ваш номер`,
  });
